import { IDictionary } from 'models/dictionary';
import { IFormElementOptionProp } from 'models/form';

export const mapDictionaryToOptionProp = (
  dictionary: IDictionary[] | null,
  prefix?: string,
  filterValues: string[] = [],
): IFormElementOptionProp[] => {
  if (!dictionary) {
    return [];
  }
  return dictionary
    .filter(
      (item) =>
        (item?.status || item?.isActive) && !filterValues.includes(item.uniqueId as string),
    )
    .map((item) => ({
      label: prefix ? `${prefix}${item.name}` : item.name,
      value: item.uniqueId,
    }));
};
